import axios from 'axios';
import { getDataOptions } from '../services/backendServices';
import { BASE_URL } from './environments';

// API's
const REGION_API = 'api/location/statesOfIndia';
const QUALIFICATION_API = 'api/qualification/';
const SPECIALITIES_API = 'api/cme/allSpecialities';
const COUNTRIES_API = 'api/location/countries';

// Services
export const getRegionsService = async () => {
  try {
    const response = await axios(getDataOptions(BASE_URL, REGION_API));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getQualificationsService = async () => {
  try {
    const config = {
      headers: { accept: 'application/json' },
      data: {},
    };
    const response = await axios.get(BASE_URL + QUALIFICATION_API, config);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getSpecialitiesService = async () => {
  try {
    const response = await axios(getDataOptions(BASE_URL, SPECIALITIES_API));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getCountriesService = async () => {
  try {
    const response = await axios(getDataOptions(BASE_URL, COUNTRIES_API));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
